import { Pipe, PipeTransform } from "@angular/core";
import { USER_STATUS } from "@comunicare/comunicare-interfaces";

@Pipe({ name: "isPractitionerEnabled", pure: true })
export class IsPractitionerEnabledPipe implements PipeTransform {
  transform(userStatus: USER_STATUS): boolean {
    return userStatus !== USER_STATUS.INACTIVE;
  }
}

@Pipe({ name: "practitionerToggleTooltipKey", pure: true })
export class PractitionerToggleTooltipKeyPipe implements PipeTransform {
  transform(userStatus: USER_STATUS): string {
    return userStatus !== USER_STATUS.INACTIVE ? "model.patient.deactivate" : "model.patient.reactivate";
  }
}
